import React, { useEffect, useRef, useState } from "react";
import { commonService } from "../../../../utils/commonService";
import { Button, Col, Table } from "react-bootstrap";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import Loader from "../../../Loader/Loader";
import DatePicker from "react-datepicker";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import moment from "moment";

const HotelKeyOccupancySnapshot = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const tableData = [
    {
      id: 1,
      propertyCode: "-",
      pullDateId: "0",
      AsOfDate: "-",
      Date: "-",
      DayOfWeek: "-",
      Inventory: "0",
      Down: "0",
      StayOvers: "0",
      FutureStayOvers: "0",
      Arrivals: "0",
      Departures: "0",
      ProjectedDepartures: "0",
      Available: "0",
      GroupAllocations: "0",
      GroupReservations: "0",
      Guaranteed: "0",
      NonGuaranteed: "0",
      Reserved: "0",
      OccupancyOOS: "0",
      Occupancy: "0",
      ConfirmedRevenue: "$",
      ProjectedRevenue: "$0",
      RevPAR: "$0",
      ADR: "$0",
    },
    {
      id: 2,
      propertyCode: "-",
      pullDateId: "0",
      AsOfDate: "-",
      Date: "-",
      DayOfWeek: "-",
      Inventory: "0",
      Down: "0",
      StayOvers: "0",
      FutureStayOvers: "0",
      Arrivals: "0",
      Departures: "0",
      ProjectedDepartures: "0",
      Available: "0",
      GroupAllocations: "0",
      GroupReservations: "0",
      Guaranteed: "0",
      NonGuaranteed: "0",
      Reserved: "0",
      OccupancyOOS: "0",
      Occupancy: "0",
      ConfirmedRevenue: "$",
      ProjectedRevenue: "$0",
      RevPAR: "$0",
      ADR: "$0",
    },
    {
      id: 3,
      propertyCode: "-",
      pullDateId: "0",
      AsOfDate: "-",
      Date: "-",
      DayOfWeek: "-",
      Inventory: "0",
      Down: "0",
      StayOvers: "0",
      FutureStayOvers: "0",
      Arrivals: "0",
      Departures: "0",
      ProjectedDepartures: "0",
      Available: "0",
      GroupAllocations: "0",
      GroupReservations: "0",
      Guaranteed: "0",
      NonGuaranteed: "0",
      Reserved: "0",
      OccupancyOOS: "0",
      Occupancy: "0",
      ConfirmedRevenue: "$",
      ProjectedRevenue: "$0",
      RevPAR: "$0",
      ADR: "$0",
    },
    {
      id: 4,
      propertyCode: "-",
      pullDateId: "0",
      AsOfDate: "-",
      Date: "-",
      DayOfWeek: "-",
      Inventory: "0",
      Down: "0",
      StayOvers: "0",
      FutureStayOvers: "0",
      Arrivals: "0",
      Departures: "0",
      ProjectedDepartures: "0",
      Available: "0",
      GroupAllocations: "0",
      GroupReservations: "0",
      Guaranteed: "0",
      NonGuaranteed: "0",
      Reserved: "0",
      OccupancyOOS: "0",
      Occupancy: "0",
      ConfirmedRevenue: "$",
      ProjectedRevenue: "$0",
      RevPAR: "$0",
      ADR: "$0",
    },
    {
      id: 5,
      propertyCode: "-",
      pullDateId: "0",
      AsOfDate: "-",
      Date: "-",
      DayOfWeek: "-",
      Inventory: "0",
      Down: "0",
      StayOvers: "0",
      FutureStayOvers: "0",
      Arrivals: "0",
      Departures: "0",
      ProjectedDepartures: "0",
      Available: "0",
      GroupAllocations: "0",
      GroupReservations: "0",
      Guaranteed: "0",
      NonGuaranteed: "0",
      Reserved: "0",
      OccupancyOOS: "0",
      Occupancy: "0",
      ConfirmedRevenue: "$",
      ProjectedRevenue: "$0",
      RevPAR: "$0",
      ADR: "$0",
    },
    {
      id: 6,
      propertyCode: "-",
      pullDateId: "0",
      AsOfDate: "-",
      Date: "-",
      DayOfWeek: "-",
      Inventory: "0",
      Down: "0",
      StayOvers: "0",
      FutureStayOvers: "0",
      Arrivals: "0",
      Departures: "0",
      ProjectedDepartures: "0",
      Available: "0",
      GroupAllocations: "0",
      GroupReservations: "0",
      Guaranteed: "0",
      NonGuaranteed: "0",
      Reserved: "0",
      OccupancyOOS: "0",
      Occupancy: "0",
      ConfirmedRevenue: "$",
      ProjectedRevenue: "$0",
      RevPAR: "$0",
      ADR: "$0",
    },
    {
      id: 7,
      propertyCode: "-",
      pullDateId: "0",
      AsOfDate: "-",
      Date: "-",
      DayOfWeek: "-",
      Inventory: "0",
      Down: "0",
      StayOvers: "0",
      FutureStayOvers: "0",
      Arrivals: "0",
      Departures: "0",
      ProjectedDepartures: "0",
      Available: "0",
      GroupAllocations: "0",
      GroupReservations: "0",
      Guaranteed: "0",
      NonGuaranteed: "0",
      Reserved: "0",
      OccupancyOOS: "0",
      Occupancy: "0",
      ConfirmedRevenue: "$",
      ProjectedRevenue: "$0",
      RevPAR: "$0",
      ADR: "$0",
    },
    {
      id: 8,
      propertyCode: "-",
      pullDateId: "0",
      AsOfDate: "-",
      Date: "-",
      DayOfWeek: "-",
      Inventory: "0",
      Down: "0",
      StayOvers: "0",
      FutureStayOvers: "0",
      Arrivals: "0",
      Departures: "0",
      ProjectedDepartures: "0",
      Available: "0",
      GroupAllocations: "0",
      GroupReservations: "0",
      Guaranteed: "0",
      NonGuaranteed: "0",
      Reserved: "0",
      OccupancyOOS: "0",
      Occupancy: "0",
      ConfirmedRevenue: "$",
      ProjectedRevenue: "$0",
      RevPAR: "$0",
      ADR: "$0",
    },
    {
      id: 9,
      propertyCode: "-",
      pullDateId: "0",
      AsOfDate: "-",
      Date: "-",
      DayOfWeek: "-",
      Inventory: "0",
      Down: "0",
      StayOvers: "0",
      FutureStayOvers: "0",
      Arrivals: "0",
      Departures: "0",
      ProjectedDepartures: "0",
      Available: "0",
      GroupAllocations: "0",
      GroupReservations: "0",
      Guaranteed: "0",
      NonGuaranteed: "0",
      Reserved: "0",
      OccupancyOOS: "0",
      Occupancy: "0",
      ConfirmedRevenue: "$",
      ProjectedRevenue: "$0",
      RevPAR: "$0",
      ADR: "$0",
    },
    {
      id: 10,
      propertyCode: "-",
      pullDateId: "0",
      AsOfDate: "-",
      Date: "-",
      DayOfWeek: "-",
      Inventory: "0",
      Down: "0",
      StayOvers: "0",
      FutureStayOvers: "0",
      Arrivals: "0",
      Departures: "0",
      ProjectedDepartures: "0",
      Available: "0",
      GroupAllocations: "0",
      GroupReservations: "0",
      Guaranteed: "0",
      NonGuaranteed: "0",
      Reserved: "0",
      OccupancyOOS: "0",
      Occupancy: "0",
      ConfirmedRevenue: "$",
      ProjectedRevenue: "$0",
      RevPAR: "$0",
      ADR: "$0",
    },
  ];

  const [occupancySnapshot, setOccupancySnapshot] = useState(null);
  const [loading, setLoading] = useState(false);
  const [startRangeDate, setStartRangeDate] = useState();
  const [endRangeDate, setEndRangeDate] = useState();
  const startRangeDateRef = useRef();
  const endRangeDateRef = useRef();
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty.defaultAsOfDate
  );
  const { snapshottitle, propertyCode, snapshotId } = useParams();
  const handleDateChange = (event) => {
    const [start, end] = event;
    let startSelectedDate = "",
      endSelectedDate = "";
    if (start) {
      let date = new Date(start);
      let month =
        date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : `0${date.getMonth() + 1}`;
      let dateFormat =
        date?.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
      startSelectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
      startRangeDateRef.current = startSelectedDate;
    }
    if (end) {
      let date = new Date(end);
      let month =
        date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : `0${date.getMonth() + 1}`;
      let dateFormat =
        date?.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
      endSelectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
      endRangeDateRef.current = endSelectedDate;
    }

    setStartRangeDate(event[0]);
    setEndRangeDate(event[1]);
    if (event[0] !== null && event[1] !== null) {
      // getOccupancySnapshot();
    }
  };

  const getOccupancySnapshot = async () => {
    setLoading(true);
    let payload = {
      AsOfDate: para?.asOfDate,
      propertyCode: para?.propertyCode,
    };

    if (startRangeDateRef.current && endRangeDateRef.current) {
      payload = {
        ...payload,
        startDate: startRangeDateRef.current,
        endDate: endRangeDateRef.current,
      };
    }
    let occupancySnapshotResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.WIDGET_MODULE.HOTEL_KEY_OCCUPANCY_SNAPSHOT,
        body: payload,
      },
      false
    );

    let response = apiResponse(false, occupancySnapshotResponse);

    if (response?.isValidate) {
      setLoading(false);
      setOccupancySnapshot(response?.data?.data);
    }

    if (!response?.isValidate) {
      setLoading(false);
      setOccupancySnapshot(null);
    }
  };

  useEffect(() => {
    if (api === 0) {
      setOccupancySnapshot(tableData);
    } else {
      if (para?.asOfDate) {
        getOccupancySnapshot();
      }
    }
  }, [para?.asOfDate]);

  const [tblids, settblids] = useState({
    tblHotelKeyOccupancySnapshot: commonService.GenerateGUID(),
  });

  return (
    <div className="widget-container" style={{position: "relative"}}>
      {api !== 0 && (
        <div className="gap-1 widget-container-menu">
          <Button className="heading-menu-btns" type="button">
            <img src={NoteIcon} alt="menuIcon" />
          </Button>
          <Button className="heading-menu-btns" type="button" title="Send Mail">
            <img id={commonService.generateGlobalClickTrackerID("HotelKeyOccupancySnapshot", "emailicon", propertyCode)}
              src={emailIcon}
              alt="emailIcon"
              onClick={() => {
                commonService.fnSendWidgetMail(
                  tblids.tblHotelKeyOccupancySnapshot,
                  "Hotel Key Occupancy Snapshot",
                  snapshotId,
                  defaultAsOfDateFromRTK,
                  "",
                  para?.widgetId
                );
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("HotelKeyOccupancySnapshot", "downloadIcon", propertyCode)}
              src={downloadIcon}
              alt="menuIcon"
              import={tblids.tblHotelKeyOccupancySnapshot}
              onClick={() =>
                commonService.fnExportInCSV(
                  tblids.tblHotelKeyOccupancySnapshot,
                  // "Hotel Key Occupancy Snapshot"
                  `${para?.propertyCode}-Hotel Key Occupancy Snapshot-${moment(
                    new Date()
                  ).format("MMDDYYYY")}`
                )
              }
            />
          </Button>
        </div>
      )}
      <div className="ViewPropertySetupTable">
        <div className="stripped__table">
          <Table
            responsive
            id={tblids.tblHotelKeyOccupancySnapshot}
            className="positionStaticTable"
          >
            <thead>
              <tr>
                <th id={commonService.generateGlobalClickTrackerID("HotelKeyOccupancySnapshot", "date-rangedatepicker", propertyCode)}
                  className="width175"
                  onClick={() => {
                    setOpenDatePicker(true);
                  }}
                >
                  Date{" "}
                                  <DatePicker id={commonService.generateGlobalClickTrackerID("HotelKeyOccupancySnapshot", "date-rangedatepicker", propertyCode)}
                                      portalId="datepicker-root"
                    onChange={(event) => handleDateChange(event)}
                    startDate={startRangeDate}
                    endDate={endRangeDate}
                    selectsRange
                    monthsShown={2}
                    open={openDatePicker}
                    shouldCloseOnSelect={false}
                  >
                    <div className="w-100" style={{ display: "inline-block" }}>
                      <div className="content-inside-calendar">
                        <p>
                          {startRangeDate
                            ? commonService.getDateInFormat(startRangeDate)
                            : ""}
                          {startRangeDate && endRangeDate ? " - " : ""}
                          {endRangeDate
                            ? commonService.getDateInFormat(endRangeDate)
                            : ""}
                        </p>
                        <div className="d-flex align-items-center gap-2">
                          <button id={commonService.generateGlobalClickTrackerID("HotelKeyOccupancySnapshot", "Cancell-date", propertyCode)}
                            className="secondary-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              setStartRangeDate("");
                              setEndRangeDate("");
                              setOpenDatePicker(false);
                            }}
                          >
                            Cancel
                          </button>
                          <button id={commonService.generateGlobalClickTrackerID("HotelKeyOccupancySnapshot", "Apply-date", propertyCode)}
                            disabled={
                              startRangeDate && endRangeDate ? false : true
                            }
                            onClick={(e) => {
                              e.stopPropagation();
                              if (
                                startRangeDateRef.current &&
                                endRangeDateRef.current
                              ) {
                                getOccupancySnapshot();
                              }

                              setOpenDatePicker(false);
                            }}
                            className="primary-btn"
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </DatePicker>
                  {startRangeDate && endRangeDate && (
                    <span
                      style={{ display: "none" }}
                    >{`${commonService.getDateInFormat(
                      startRangeDate
                    )} - ${commonService.getDateInFormat(endRangeDate)}`}</span>
                  )}
                </th>
                <th colSpan={23}></th>
              </tr>
              <tr>
                {/* <th className="width100">property Code</th>
                <th className="width100">pull Date Id</th> */}
                <th className="width100">As Of Date</th>
                <th className="width100">Date</th>
                <th className="width100">Day Of Week</th>
                <th className="width100 text-center">Inventory</th>
                <th className="width100 text-center">Down</th>
                <th className="width100 text-center">Stay Overs</th>
                <th className="width100 text-center">Future Stay Overs</th>
                <th className="width100 text-center">Arrivals</th>
                <th className="width100 text-center">Departures</th>
                <th className="width100 text-center">Projected Departures</th>
                <th className="width100 text-center">Available</th>
                <th className="width100 text-center">Group Allocations</th>
                <th className="width100 text-center">Group Reservations</th>
                <th className="width100 text-center">Guaranteed</th>
                <th className="width100 text-center">Non Guaranteed</th>
                <th className="width100 text-center">Reserved</th>
                <th className="width100 text-center">Occupancy OOS</th>
                <th className="width100 text-center">Occupancy</th>
                <th className="width100 ">Confirmed Revenue</th>
                <th className="width100">Projected Revenue</th>
                <th className="width100">RevPAR</th>
                <th className="width100">ADR</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr style={{ height: "80px", position: "relative" }}>
                  <Loader />
                </tr>
              ) : occupancySnapshot && occupancySnapshot?.length > 0 ? (
                occupancySnapshot?.map((item, index) => (
                  <tr key={item?.id} className="shadowOnHover">
                    {/* <td>{item?.propertyCode}</td>
                    <td>{item?.pullDateId}</td> */}
                    <td className="text-start">
                      {item?.AsOfDate
                        ? commonService.getDateInFormat(item?.AsOfDate)
                        : ""}
                    </td>
                    <td className="text-start">
                      {item?.Date
                        ? commonService.getDateInFormat(item?.Date)
                        : ""}
                    </td>
                    <td className="text-center">{item?.DayOfWeek}</td>
                    <td className="text-center">{item?.Inventory}</td>
                    <td className="text-center">{item?.Down}</td>
                    <td className="text-center">{item?.StayOvers}</td>
                    <td className="text-center">{item?.FutureStayOvers}</td>
                    <td className="text-center">{item?.Arrivals}</td>
                    <td className="text-center">{item?.Departures}</td>
                    <td className="text-center">{item?.ProjectedDepartures}</td>
                    <td className="text-center">{item?.Available}</td>
                    <td className="text-center">{item?.GroupAllocations}</td>
                    <td className="text-center">{item?.GroupReservations}</td>
                    <td className="text-center">{item?.Guaranteed}</td>
                    <td className="text-center">{item?.NonGuaranteed}</td>
                    <td className="text-center">{item?.Reserved}</td>
                    <td className="text-center">{item?.OccupancyOOS}</td>
                    <td className="text-center">{item?.Occupancy}</td>
                    <td className="">{item?.ConfirmedRevenue}</td>
                    <td>{item?.ProjectedRevenue}</td>
                    <td>{item?.RevPAR}</td>
                    <td>{item?.ADR}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={24} className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default HotelKeyOccupancySnapshot;
